import type { SVGProps } from 'react';

const SvgNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M8 3a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5H8Zm1.88 4.844A.9.9 0 0 0 8.27 8.4v7.2a.9.9 0 0 0 1.8 0v-4.598l4.05 5.154a.9.9 0 0 0 1.607-.556V8.4a.9.9 0 1 0-1.8 0v4.598L9.88 7.844Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgNew;
